import React, { useEffect, useRef, useState } from 'react';
import "./teststart.css";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Content from '../AllPageContent/AllPageContent';
import subjimg1 from "../../Image/sub1.png";
import subjimg2 from "../../Image/sub2.png";
import subjimg3 from "../../Image/sub3.png";
import subjimg4 from "../../Image/sub4.png";
import subjimg5 from "../../Image/sub5.png";
import { saveAs } from 'file-saver';
import { useAlert } from 'react-alert';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeModal from '../YoutubeModal/YoutubeModal';
import { BASE_URL } from '../../insightConfig/insightConfig';
import $, { data } from 'jquery';
import swal from 'sweetalert';
import { SlArrowLeft } from 'react-icons/sl';
import { Spinner } from 'react-bootstrap';
import { RiDownload2Fill } from 'react-icons/ri';
import { HiDownload } from "react-icons/hi";

function TestStart() {

    const storedAuthToken = localStorage.getItem('authtoken');
    const [testReport, setTestreport] = useState({})


    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadedFilePath, setUploadedFilePath] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [evaluatedFile, setEvaluatedFile] = useState(null)
    const [answerLink, setAnswerLink] = useState(null)
    const [attemptCount, setAttemptCount] = useState(null)
    const [laodAnswer, setLoadAnswer] = useState(false)
    const [fileUploading, setFileUploading] = useState(false);
    const alert = useAlert();
    const fileInputRef = useRef(null);
    const navigate = useNavigate()

    const location = useLocation();
    const { courseId, testSeriesSn, packageId, emailId } = useParams();
    const [testData, setTestData] = useState({});
    console.log(testData);


    useEffect(() => {
        // Update state only if location state is available
        // if (location?.state?.testData) {
        //     setTestData(location.state.testData);
        // }
        if (emailId) {
            localStorage.setItem('authtoken', emailId);
            localStorage.setItem('isLoggedIn', true);
        }


        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/single-test-data/${courseId}/${testSeriesSn}/${packageId}`);
                setTestData(response.data.data);

                localStorage.setItem("CurrentTestSeriesTitleURL", JSON.stringify(response?.data?.data?.TitleHeading));
                localStorage.setItem('isLoggedIn', true);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();



    }, [courseId, packageId, location]);




    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);

    };
    const handleUploadFile = () => {
        fileInputRef.current.click(); // Trigger click event on file input
    };
    useEffect(() => {
        if (selectedFile) {
            setFileUploading(true)
            //upload image on server
            const formData = new FormData();
            formData.append('uploadedFile', selectedFile, selectedFile.name);
            axios.post(BASE_URL + '/uploadFile', formData)
                .then((response) => {
                    if (response.data.statusCode == 201) {
                        setUploadedFilePath(response.data.imagePath)
                    }
                })
                .catch(error => {

                });
        }
    }, [selectedFile])
    const date = new Date();



    useEffect(() => {
        if (uploadedFilePath) {

            const formattedDate = date.toLocaleDateString('en-CA'); // 'en-CA' gives YYYY-MM-DD format
            console.log(formattedDate); // "2025-10-13"

            axios.post(BASE_URL + '/upload-subjecive-answer', { packageId: testData?.PackageID, studentEmailId: storedAuthToken, answerPdfLink: uploadedFilePath, UploadDate: formattedDate, attemptCount: attemptCount ?? 0 })
                .then((response) => {
                    if (response.data.statusCode == 200) {
                        setLoadAnswer(!laodAnswer)
                        setFileUploading(false)
                        swal(response.data.message, {
                            icon: "success",
                            buttons: {
                                confirm: {
                                    text: "OK",
                                    value: true,
                                    visible: true,
                                    closeModal: true
                                }
                            }
                        })
                    }

                })
                .catch(error => {
                    swal("Oops", "Something went wrong! Please Try Again", { icon: "error" })

                });
        }
    }, [uploadedFilePath])














    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };




    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/get-answer-and-evaluated-copy/${testData?.PackageID}`);
                setEvaluatedFile(response?.data?.EvaluateCopyLink[0]?.EvaluateCopyLink);
                setAnswerLink(response?.data?.EvaluateCopyLink[0]?.AnswerLink);
                setAttemptCount(response?.data?.EvaluateCopyLink[0]?.AttemptCount);
                // 
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (testData?.Type && testData?.Type !== "MCQ") fetchData();

    }, [testData?.PackageID, laodAnswer]);

    useEffect(() => {
        if (testData.testSeriesSn && testData.PackageID) {
            axios.get(BASE_URL + `/get-test-report/${testData.testSeriesSn}/${testData.PackageID}`).then((respnse) => {
                setTestreport(respnse.data.report);
            }).catch(error => {
                console.error("Error fetching test report:", error);
            })
        }
    }, [testData?.PackageID, testData?.testSeriesSn])





    console.log(testReport);


    const viewReportJSX = <Link to={`/TestResultDetailView`} state={{ testData, testReport }} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-5">VIEW REPORT</Link>

    const reAttemptJSX = <Link to={`/testseriesstart/${testData?.PackageID}`} state={{ testData: { ...testData, reAttempt: true } }} type="button" className="btn bg-Question-white btn-md col-md-5">REATTEMPT</Link>

    const continueJSX = <Link to={`/testseriesstart/${testData?.PackageID}`} state={{ testData }} type="button" className="btn bg-Question-white btn-md col-md-5">CONTINUE</Link>

    const startJSX = <Link to={`/testseriesstart/${testData?.PackageID}`} state={{ testData: { ...testData, reAttempt: false } }} type="button" className="btn bg-Question-white btn-md col-md-5">START</Link>



    const selectTestStartButtons = () => {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("TestSeriesReportArray"));
        const currentTest = allTestsReportsArray?.find((test) => test.packageId == testData?.PackageID);

        if (currentTest) {
            if (testData?.Status == 'Complete') {
                return (
                    <div className='d-md-flex justify-content-start'>
                        {continueJSX}
                        {viewReportJSX}
                    </div>
                )
            } else {
                return (
                    <div className='d-md-flex justify-content-start'>
                        {continueJSX}
                    </div>
                )
            }

        } else {
            if (testData?.Status == 'Complete') {
                if (testData?.AttemptFinished == 0) {
                    return (
                        <div className='d-md-flex justify-content-start'>
                            {reAttemptJSX}
                            {viewReportJSX}
                        </div>
                    )
                } else {
                    return (
                        <div className='d-md-flex justify-content-start'>
                            {viewReportJSX}
                        </div>
                    )
                }
            } else {
                return (
                    <div className='d-md-flex justify-content-start'>
                        {startJSX}
                    </div>
                )
            }
        }

    }
    const currentTestSeriesTitleURL = JSON.parse(localStorage.getItem("CurrentTestSeriesTitleURL"));



    const setButtonName = () => {
        if (fileUploading) {
            return <Spinner size='sm' className='fs-5 m-0' variant="light" />
        } else if (answerLink) {
            return 'UPLOADED'
        } else {
            return 'UPLOAD'
        }


        // answerLink ? 'UPLOADED' : 'UPLOAD'
    }
    const isValidUrl = (filePath) => {
        return filePath?.toString()?.includes('.');
    };

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    {testData?.Sn ? <>
                        <div className='col-lg-3 test-background p-3 pt-2'>
                            <button onClick={() => navigate('/testseries/' + currentTestSeriesTitleURL)} className='btn btn-sm btn-info mb-2 mt-0'><SlArrowLeft /> Back</button>
                            <div className='d-grid gap-3'>
                                <button type="button" className="btn bg-darkblue btn-md py-2">
                                    {testData?.Type === "MCQ" ? <>PTS-{testData?.AccessCode}</> : <>MTS-{testData?.AccessCode}</>} : {testData?.Title}
                                    <hr className='my-1' />
                                    {testData?.QuestionCount} Ques | {testData?.Duration} min | {testData?.MarksTotal} marks
                                </button>
                                <button type="button" className="btn bg-darkorange btn-md py-3">OVERVIEW</button>
                                {testData?.Type === 'MCQ' && <button type="button" className="btn bg-darkorange btn-md py-3" onClick={() => window.open(testData?.ModelAnswerPDF, '_blank')}>EXPLANATION</button>}
                                {testData?.VideoUrl != '' && testData.VideoUrl != 'N' && <button type="button" onClick={openModal} className="btn bg-darkgreen text-white btn-md p-3">VIDEO DISCUSSION</button>}
                            </div>
                        </div>
                        <div className='col-lg-9 teststart-padding'>
                            <div className='p-3 mb-4 rounded-2' style={{ background: "#fffde4", boxShadow: "0 10px 15px rgba(0,0,0,0.3)" }}>
                                {testData?.Type === "MCQ" ? <Content paragraphs={testData?.MCQRules} /> : <Content paragraphs={testData?.SubjectiveRules} />}
                            </div>
                            {testData?.Type === 'MCQ' ? <><div className='d-grid w-50 gap-3'>
                                {selectTestStartButtons()}
                            </div></> :
                                <div className='container-fluid'>
                                    <div className='d-sm-flex' style={{ overflow: "scroll" }}>
                                        <div className="d-flex justify-content-around">
                                            <div className='p-sm-3 p-2'>
                                                <div className='d-flex flex-column align-items-center'>
                                                    <img src={subjimg1} alt='...' />
                                                    <p style={{ fontWeight: "600" }} className='text-center py-sm-1'>Question Paper</p>
                                                    <button disabled={!isValidUrl(testData?.QuestionPDF)} type="button" onClick={() => window.open(testData?.QuestionPDF, '_blank')} className="btn bg-Question-white  btn-sm px-sm-5 px-3">DOWNLOAD</button>
                                                </div>
                                            </div>
                                            <div className='p-sm-3 p-2'>
                                                <div className='d-flex flex-column align-items-center'>
                                                    <img src={subjimg2} alt='...' />
                                                    <p style={{ fontWeight: "600" }} className='py-sm-1 text-center'>Answer Booklet</p>
                                                    <button disabled={!isValidUrl(testData?.AnswerBookletPDF)} type="button" onClick={() => window.open(testData?.AnswerBookletPDF, '_blank')} className="btn bg-Question-white px-sm-5 px-3 btn-sm">DOWNLOAD</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-around">
                                            <div className='p-sm-3 p-2'>
                                                <div className='d-flex flex-column align-items-center'>
                                                    <img src={subjimg3} alt='...' />
                                                    <p style={{ fontWeight: "600" }} className='py-sm-1 d-flex text-center'>Your Answer {answerLink && <RiDownload2Fill style={{ cursor: "pointer" }} onClick={() => window.open(answerLink, '_blank')} className='ms-2 ' color='#e52626' size={20} />}</p>
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: 'none' }}
                                                        accept='.pdf'
                                                        onChange={handleFileChange}
                                                        className='form-control' />
                                                    <button disabled={attemptCount && attemptCount >= testData?.Attempt} type="button" onClick={handleUploadFile} className="btn bg-Question-white px-sm-5 px-3 btn-sm">{setButtonName()}</button>
                                                </div>
                                            </div>
                                            <div className='p-sm-3 p-2'>
                                                <div className='d-flex flex-column align-items-center'>
                                                    <img src={subjimg5} alt='...' />
                                                    <p style={{ fontWeight: "600" }} className='py-sm-1 text-center'>Model Answer</p>
                                                    <button disabled={!isValidUrl(testData?.ModelAnswerPDF)} type="button" onClick={() => window.open(testData?.ModelAnswerPDF, '_blank')} className="btn bg-Question-white px-sm-5 px-3 btn-sm">DOWNLOAD</button>
                                                </div>
                                            </div>
                                        </div>


                                        {/* <div className='p-sm-3 p-2'>
                                        <div className='d-flex flex-column align-items-center'>
                                            <img src={subjimg3} alt='...' />
                                            <p className='py-sm-1 text-center'>Your Answer</p>
                                            <div className='d-flex justidy-content-content-center align-items-center'>
                                                <button className={selectedFile ? "btn bg-Question-white px-5 py-0 btn-sm button upload" : 'btn bg-Question-white px-5 btn-sm button2'} style={{ height: "50px" }}>
                                                    <span><input style={{ display:'none' }} type="file" className="" accept='application/pdf' required name="image" id="inputGroupFile01" ref={fileInputRef} onChange={handleClick} /></span>
                                                </button>
                                            </div>
                                        </div>
                                      
                                    </div>                                    */}

                                        <div className='p-sm-3 p-2'>
                                            <div className='d-flex flex-column align-items-center'>
                                                <img src={subjimg4} alt='...' />
                                                <p style={{ fontWeight: "600" }} className='py-1 text-center'>Evaluated Copy</p>
                                                <button disabled={!evaluatedFile} type="button" onClick={() => window.open(evaluatedFile, '_blank')} className="btn bg-Question-white px-5 btn-sm">DOWNLOAD</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>}
                        </div>
                    </> :
                        <div className="d-flex flex-column justify-content-center align-items-center h-25 bg-light shadow rounded p-3" style={{ minHeight: "10rem" }}>
                            <h4 className="text-secondary mb-2" style={{ fontWeight: "600" }}>Loading test details...</h4>
                            <span>
                                <Spinner animation="grow" variant="info" role="status" style={{ width: "2rem", height: "2rem" }} />
                            </span>
                        </div>


                    }

                </div>
            </div>
            <Modal show={isOpen} centered className="animate__animated animate__fadeIn mobileyoutube">
                <YoutubeModal closeModal={closeModal} VideoId={testData?.VideoUrl} />
            </Modal>
        </>
    )
}

export default TestStart




